<div class="page-content ">
    <div class="row justify-content-center">
        <div class="col-xxl-6 col-xl-6 col-lg-6 pt-5 pb-5 justify-content-center">
            <div class="login-area bg-light">
                <h2 class="text-secondary text-center">Login</h2>
                <p class="text-center m-b25">Welcome, please login to your account</p>
                <div *ngIf="message" class="mt-3 text-center"
                    [ngClass]="{'text-success': isSuccess, 'text-danger': !isSuccess}">
                    {{ message }}
                </div>
                <form *ngIf="loginMode === 'password'" (ngSubmit)="onLogin()">
                    <div class="m-b30">
                        <label class="label-title">Email Address</label>
                        <input name="email" required class="form-control" placeholder="Email Address" type="email"
                            [(ngModel)]="user.email" #emailInput="ngModel">
                        <div *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched)"
                            class="text-danger mt-1">
                            <div *ngIf="emailInput.errors?.['required']">
                                Email is required.
                            </div>
                            <div *ngIf="emailInput.errors?.['email']">
                                Please enter a valid email address.
                            </div>
                        </div>
                    </div>
                    <div class="m-b15">
                        <label class="label-title">Password</label>
                        <div class="secure-input">
                            <input [type]="passwordFieldType" name="password" class="form-control dz-password"
                                placeholder="Password" [(ngModel)]="user.password" #passwordInput="ngModel" required>
                            <div class="show-pass" (click)="togglePasswordVisibility()">
                                <i class="fa-regular"
                                    [ngClass]="{'fa-eye': !passwordVisible, 'fa-eye-slash': passwordVisible}"></i>
                            </div>
                        </div>
                        <div *ngIf="passwordInput.invalid && (passwordInput.dirty || passwordInput.touched)"
                            class="text-danger mt-1">
                            <div *ngIf="passwordInput.errors?.['required']">
                                Password is required.
                            </div>
                        </div>
                    </div>
                    <div class="form-row d-flex justify-content-between m-b30">
                        <div class="form-group">
                            <a href="javascript:void(0)" class="text-primary" (click)="changeLoginMode('otp')">Login with OTP</a>
                        </div>
                        <div class="form-group">
                            <a class="text-primary" href="/forgot-password">Forgot Password</a>
                        </div>
                    </div>
                    <div class="text-center">
                        <button type="submit" class="btn btn-secondary btnhover text-uppercase me-2 sign-btn">Sign
                            In</button>
                    </div>
                </form>

                <!-- OTP-based Login Forms -->
                <div *ngIf="loginMode === 'otp'">
                    <!-- Step 1: Request OTP Form -->
                    <div *ngIf="otpLoginStep === 'request_otp'">
                        <h2 class="text-secondary text-center">Login with OTP</h2>
                        <p class="text-center m-b25">Enter your e-mail address to receive an OTP.</p>
                        <form (ngSubmit)="onRequestOtp()">
                            <div class="m-b30">
                                <label class="label-title">Email Address</label>
                                <input name="otpEmail" required class="form-control" placeholder="Email Address"
                                    type="email" [(ngModel)]="otpEmail">
                            </div>
                            <div class="d-flex justify-content-between">
                                <a class="btn btn-outline-secondary btnhover text-uppercase"
                                    (click)="changeLoginMode('password')">Back to Password Login</a>
                                <button type="submit" class="btn btn-secondary btnhover text-uppercase submit-btn"
                                    [disabled]="isLoading">
                                    {{ isLoading ? 'Sending...' : 'Send OTP' }}
                                </button>
                            </div>
                        </form>
                    </div>

                    <!-- Step 2: Verify OTP Form -->
                    <div *ngIf="otpLoginStep === 'verify_otp'" class="">
                        <h2 class="text-secondary text-center">Verify OTP</h2>
                        <p class="text-center m-b25">Enter the OTP sent to your email to log in.</p>
                        <form (ngSubmit)="onVerifyOtp()">
                            <div class="m-b30">
                                <label class="label-title">Email Address</label>
                                <input name="otpEmailReadonly" required class="form-control" placeholder="Email Address"
                                    type="email" [(ngModel)]="otpEmail" readonly>
                            </div>
                            <div class="m-b30">
                                <label class="label-title">OTP</label>
                                <input name="otpCode" required class="form-control" placeholder="Enter OTP" type="text"
                                    [(ngModel)]="otpCode">
                            </div>
                            <div class="d-flex justify-content-between">
                                <button type="button" class="btn btn-outline-secondary btnhover text-uppercase"
                                    (click)="backToOtpRequest()">Back</button>
                                <button type="submit" class="btn btn-secondary btnhover text-uppercase sign-btn"
                                    [disabled]="isLoading">
                                    {{ isLoading ? 'Verifying...' : 'Verify OTP & Login' }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>